import { BrowserRouter as Router } from 'react-router-dom'
import { InterceptAuthApp } from './routes/InterceptAuthApp'

const App = (): JSX.Element => {
  return (
    <Router>
      <InterceptAuthApp />
    </Router>
  )
}

export { App }
